import { jsx as i, jsxs as h } from "react/jsx-runtime";
import v from "react";
import t, { css as n } from "styled-components";
import { c as x, u as y } from "../chunks/useClickMotion.0a3ea4e5.js";
import { b as k, e as w, _ as C } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { R as I } from "../chunks/index.cff5baaf.js";
const c = {
  sm: "var(--size-15x)",
  lg: "var(--size-20x)"
}, M = {
  sm: w,
  lg: C
}, j = t.button.withConfig({
  displayName: "ShortcutIcon",
  componentId: "sc-jt6s75-0"
})(["", " all:unset;display:flex;justify-content:center;align-items:center;padding:var(--spacing-2x);background-color:var(--elements-bg-color-02);border-radius:var(--default-border-radius);cursor:pointer;transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);&:hover{transition-timing-function:var(--curve-productive-entrance);opacity:var(--hover-container);}&:focus-visible{", " outline-offset:2px;}", " ", " ", ""], (o) => o.$isClickMotion && x(), k, (o) => o.size && n(["width:", ";height:", ";"], c[o.size], c[o.size]), (o) => o.disabled && n(["background-color:var(--disabled-bg-color);opacity:var(--opacity-low);cursor:not-allowed;pointer-events:none;", "{color:var(--on-disabled-icon-color);}", "{color:var(--on-disabled-label-color);}"], s, e), ({
  size: o
}) => o && n(["", "{", "}"], e, M[o])), s = t(I).withConfig({
  displayName: "Icon",
  componentId: "sc-jt6s75-1"
})(["color:var(--on-elements-icon-color);"]), e = t.span.withConfig({
  displayName: "LabelWrapper",
  componentId: "sc-jt6s75-2"
})(["text-align:left;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;color:var(--on-text-label-color);line-height:var(--line-height-sm);"]), S = t.div.withConfig({
  displayName: "Content",
  componentId: "sc-jt6s75-3"
})(["display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;width:100%;height:100%;z-index:1;"]), z = {
  LG: "lg",
  SM: "sm"
}, R = v.forwardRef(({
  children: o,
  icon: l,
  size: d = z.LG,
  disabled: a = !1,
  ariaLabel: p,
  onClick: r,
  ...m
}, u) => {
  const {
    isClickMotion: f,
    startClickMotion: g
  } = y();
  return /* @__PURE__ */ i(j, { disabled: a, "aria-disabled": a, $isClickMotion: f, size: d, "aria-label": p, "data-rango-component": "rango-shortcut-icon", "data-is-rango": "true", ...m, ref: u, onClick: (b) => {
    r && r(b), g();
  }, "data-testid": "rango-shortcut-icon", children: /* @__PURE__ */ h(S, { children: [
    /* @__PURE__ */ i(s, { icon: l }),
    /* @__PURE__ */ i(e, { children: o })
  ] }) });
});
R.displayName = "RangoShortcutIcon";
export {
  R as RangoShortcutIcon
};
